import React from 'react';

import * as Antd from 'antd';
import * as SYS from './';

export const PageForm = props => {
    const [form] = Antd.Form.useForm();

    const layout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
    };

    const tailLayout = {
        wrapperCol: { span: 18, offset: 6 },
    };

    return (
        <Antd.Form
            {...layout}
            form={form}
            initialValues={props.initialValues}
            onFinish={values => {
                values.content = btoa(values.decodedContent);
                delete values.decodedContent;
                if (props.onSuccess) {
                    props.onSuccess(values);
                }
            }}
            onFinishFailed={(err) => {
                console.log(err);
            }}
        >
            <Antd.Row>
                <Antd.Col span={8}>
                    {props.initialValues && props.initialValues.id
                        ? <Antd.Form.Item name="id" label="ID">
                            <Antd.Input disabled={true} />
                        </Antd.Form.Item>
                        : null}
                    <Antd.Form.Item
                        name="name"
                        label="Name"
                        rules={[{ required: true }]}
                    >
                        <Antd.Input />
                    </Antd.Form.Item>
                    <Antd.Form.Item
                        name="path"
                        label="Path"
                        rules={[{ required: true }]}
                    >
                        <Antd.Input />
                    </Antd.Form.Item>
                    <Antd.Form.Item
                        name="roles"
                        label="Roles"
                        help={"Blank = dany all"}
                    >
                        <SYS.UserRoleSelect
                            mode="tags"
                        />
                    </Antd.Form.Item>
                    <Antd.Form.Item
                        name="menu"
                        label="Menu"
                    >
                        <Antd.Select>
                            <Antd.Select.Option value={null}>No menu</Antd.Select.Option>
                            <Antd.Select.Option value="main">Main</Antd.Select.Option>
                        </Antd.Select>
                    </Antd.Form.Item>
                    <Antd.Form.Item
                        name="menuTitle"
                        label="Menu title"
                    >
                        <Antd.Input
                            allowClear={true}
                        />
                    </Antd.Form.Item>
                    <Antd.Form.Item
                        name="menuLink"
                        label="Menu link"
                    >
                        <Antd.Input
                            allowClear={true}
                        />
                    </Antd.Form.Item>
                    <Antd.Form.Item                        
                        name="menuOrder"
                        label="Menu order"
                    >
                        <Antd.InputNumber />
                    </Antd.Form.Item>
                    <Antd.Form.Item
                        label="Is modal"
                        name="isModal"
                        fieldKey="isModal"
                        valuePropName="checked"
                        style={{
                            marginBottom: 30
                        }}
                    >
                        <Antd.Switch />
                    </Antd.Form.Item>
                </Antd.Col>
                <Antd.Col span={16}>
                    <Antd.Form.Item
                        noStyle
                        name="decodedContent"
                        label="Content"
                        help="Antd, COM, Moment, userProfile, params"
                        rules={[{ required: true }]}
                    >
                        <SYS.PageEditor />
                    </Antd.Form.Item>
                </Antd.Col>
            </Antd.Row>

            <Antd.Form.Item
                {...tailLayout}
                style={{
                    marginTop: 10
                }}
            >
                <Antd.Button
                    type="primary"
                    htmlType="submit"
                >
                    Submit
                </Antd.Button>
            </Antd.Form.Item>
        </Antd.Form >
    );
}